import { useQuery } from '@tanstack/react-query';
import { Handshake, ListTodo } from 'lucide-react';
import type { CriacaoWeb, PropsCriacao } from '../../nucleo/modulos-web';
import { get } from '../../nucleo/api';
import { useSessao } from '../../nucleo/sessao';
import { CriarNegociacaoCrm } from './CriarNegociacaoCrm';
import { podeCriarTarefaNaNegociacao } from './negociacao-edicao';
import type { Oportunidade } from './tipos';
import { FormTarefa, rascunhoInicial } from './FormTarefa';

/**
 * Ajustes do CRM 27/10 (C6, K2): as criações do Pipeline no botão flutuante e no menu "Criar" da casca nova. Negociação (o
 * formulário único, C8) e tarefa (o de sempre, com a empresa da página; rodada rrl-3, SPEC-M1: na ficha do contato, a busca de
 * negociação e "Criar negociação" seguem a empresa dele, e a reunião sem negociação fica ligada ao contato). Lista de 30/10 B (item 1): o "Criar funil" saiu do
 * botão flutuante (os funis seguem em Configurações do CRM > Funis) e a ordem de cima para baixo é Negociação, Tarefa, Empresa
 * e Contato (a `posicao`).
 */
function CriarTarefa({ aoFechar, contexto }: PropsCriacao) {
  const s = useSessao();
  const parceiro = contexto.empresa ?? contexto.contato;
  const negId = contexto.negociacao?.id;
  // rl0211-2 (VIS-M1): reunião ligada a uma negociação aberta (e fora da pausa) abre a tarefa DENTRO dela, como na ficha. Se a
  // negociação não se lê (404, sem visão) ou já encerrou, segue como antes (só o parceiro); espera a leitura para não montar duas vezes.
  const neg = useQuery({ queryKey: ['pipeline', 'oportunidade', negId], queryFn: () => get<Oportunidade>(`/pipeline/oportunidades/${negId}`), enabled: !!negId, retry: false });
  if (negId && neg.isPending) return null;
  if (negId && neg.data && podeCriarTarefaNaNegociacao(neg.data, true)) {
    const o = neg.data;
    return <FormTarefa travarNegociacao inicial={rascunhoInicial(s.usuario.id, { parceiroId: o.parceiro_id, parceiroNome: o.parceiro_nome, oportunidadeId: o.id, oportunidadeTitulo: o.titulo })} aoFechar={aoFechar} />;
  }
  return <FormTarefa inicial={rascunhoInicial(s.usuario.id, parceiro ? { parceiroId: parceiro.id, parceiroNome: parceiro.nome, contatoDaReuniaoId: contexto.empresa ? (contexto.contato?.id ?? null) : null } : {})} aoFechar={aoFechar} />;
}

export const criacoesPipeline: CriacaoWeb[] = [
  { chave: 'negociacao', rotulo: 'criacao.itens.negociacao', icone: Handshake, permissao: 'pipeline.criar', subsistemas: ['crm'], posicao: 10, componente: CriarNegociacaoCrm },
  { chave: 'tarefa', rotulo: 'criacao.itens.tarefa', icone: ListTodo, permissao: 'pipeline.criar', subsistemas: ['crm'], posicao: 20, componente: CriarTarefa },
];
